// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__l4yBn","modal__body":"Modal_modal__body__Pa_ff","modal__button-close":"Modal_modal__button-close__c8cyo"};